import { FilterParams } from "@/models/tpp-claims/FilterParams";

export const generateFilterQuery = (params: FilterParams) => {
  let claimNumber = "";
  let date = "";
  let locationCode = "";
  let lossType = "";
  let reporterName = "";
  let status = "";

  // Generate claim number filter
  if (params.claim_number) {
    claimNumber = `filters[claim_number]=${params.claim_number}`;
  }

  // Generate date filter
  if (params.date) {
    date = `filters[date]=${params.date}`;
  }

  // Generate reporter name filter (can be first name or last name, or both)
  if (params.name && params.name.length) {
    reporterName = generateParams(params.name.toUpperCase(), "reporter_name");
  }

  // Generate location codes ([] of location codes)
  if (params.location_code && params.location_code.length) {
    locationCode = generateParams(params.location_code, "location_code");
  }

  // Generate claim status ([] of claim statuses)
  if (params.status && params.status.length) {
    status = generateParams(params.status, "status");
  }

  // Generate loss types ([] of loss types)
  if (params.loss_type && params.loss_type.length) {
    lossType = generateParams(params.loss_type, "loss_type");
  }

  // Need to create an array of each param URL to properly join into a single line
  const joinedParams = [reporterName, date, claimNumber, locationCode, status, lossType];

  // This joins every param that has value with a '&' and makes a single string
  const finalizedParamURL = joinedParams.filter(param => {
    if (param && param.length) {
      return param;
    }
  }).join("&");

  return finalizedParamURL;
};

export const generateParams = (paramKey: string | string[], filterName: string) => {
  // Handles multi params (location_code, status, loss_type)
  if (paramKey && Array.isArray(paramKey)) {
    return paramKey.map(param => {
      return `filters[${filterName}][]=${param}`;
    }).join("&");
  }

  // Handles single params (reporter_name, claim_number, date)
  return `filters[${filterName}][]=${paramKey}`;
};
